// extracted by mini-css-extract-plugin
var _1 = "SettingsSection-moduleSettingsSection__fFJaf";
var _2 = "SettingsSection-moduledescription__ngcsG";
var _3 = "SettingsSection-moduleheader__SzUI8";
var _4 = "SettingsSection-moduletitle__ehdq3";
var _5 = "SettingsSection-moduletitleContainer__GNkhw";
export { _1 as "SettingsSection", _2 as "description", _3 as "header", _4 as "title", _5 as "titleContainer" }
